export default __webpack_public_path__ + "static/media/favicon.6a494895.ico";